import React from 'react';
import PropTypes from 'prop-types';

import classes from './TransformerTable.css';
import translation from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const transformerTable = props => {
  const { phase, country, language } = props;
  const transformerData = require(`../../../assets/data/AppData/${country}/TransformerData/TransformerData.json`);

  let selectedPhase = transformerData.singlePhase;
  const tableRows = [];

  if (phase === 'three') {
    selectedPhase = transformerData.threePhase;
  }

  Object.keys(selectedPhase).forEach(i => {
    const row = (
      <tr key={i}>
        <td>{selectedPhase[i].KAVRating}</td>
        <td>{selectedPhase[i].amperes[props.voltage]}</td>
      </tr>
    );
    tableRows.push(row);
  });

  tableRows.reduce((arr, el) => arr.concat(el), []);

  return (
    <table className={classes.TransformerTable}>
      <thead>
        <tr>
          <th>{translation[language]['KVArating']}</th>
          <th>{translation[language]['amperes']}</th>
        </tr>
      </thead>
      <tbody>{tableRows}</tbody>
    </table>
  );
};

transformerTable.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  phase: PropTypes.string.isRequired
};

export default transformerTable;
